import { useState } from 'react'
import { createMacroTrackers, saveMacroTrackerMeal } from '../utils/macro-tracker-utils'
import { handleError } from '../../lib/utils'
import { message } from 'antd'
import { useSelector } from 'react-redux'
import { assistantInitiate } from '../../AI Tools/utils'
import { uploadFile } from '../../Admin/config/utils/utils'
import { AssistantEnums } from '../../AI Tools/assitants-enums'
import { generateAIResponse } from '../../AI Tools/assistants-lib'

const useMobileNewImage = ({ setModalOpen, savedMeals, setSavedMeals, limits, handleRefresh }) => {
  const authState = useSelector((state) => state.auth)
  const [contactingAi, setContactingAi] = useState(false)
  const [macroData, setMacroData] = useState(null)
  const [saveToFavourites, setSaveToFavourites] = useState(false)
  const [saving, setSaving] = useState(false)
  const [servings, setServings] = useState(1)
  const [uploadedImage, setUploadedImage] = useState(null)
  const [aiError, setAiError] = useState(null)

  const contactMacroAssistantAi = async (base64, file) => {
    setContactingAi(true)
    setAiError(null)
    try {
      const contentType = file.type
      const uploadResponse = await uploadFile('Test', contentType, file, false, true)
      const fileId = uploadResponse?._id
      const fileUrl = `https://nodered-metahealth-dev.agilite.io/api/images/${fileId}.jpeg`

      const aiInitiateResponse = await assistantInitiate(
        [
          {
            type: 'image_url',
            image_url: { url: fileUrl }
          }
        ],
        AssistantEnums.assistant_ids.MACRO_TRACKER
      )

      const aiContentResponse = await generateAIResponse(aiInitiateResponse)
      const tmpMacroData = JSON.parse(aiContentResponse?.data?.data[0]?.content[0]?.text?.value)

      if (!tmpMacroData.macros) {
        setAiError(tmpMacroData.error)
      } else {
        setUploadedImage(base64)
        setMacroData(tmpMacroData)
      }
    } catch (error) {
      message.error('Failed to analyze image. Please try again.')
    }
    setContactingAi(false)
  }

  const handleCreateNewMacroEntry = async () => {
    const payload = JSON.parse(JSON.stringify(macroData))

    for (let key in payload.macros) {
      if (payload.macros.hasOwnProperty(key)) {
        payload.macros[key] = payload.macros[key] * servings
      }
    }

    if (payload._id) {
      delete payload._id
      delete payload.createdAt
      delete payload.createdBy
      delete payload.userRef
    }

    payload.createdBy = authState.agiliteUser._id
    payload.userRef = authState.agiliteUser._id
    payload.servings = servings
    payload.image = uploadedImage

    setSaving(true)
    try {
      await createMacroTrackers(payload)
      if (saveToFavourites) {
        const newMealFavourite = await saveMacroTrackerMeal({
          ...payload,
          ...macroData,
          servings: 1
        })
        setSavedMeals([...savedMeals, newMealFavourite])
      }
      handleRefresh()
      setModalOpen(false)
    } catch (error) {
      message.error(handleError(error))
    }
    setSaving(false)
  }

  return {
    contactMacroAssistantAi,
    contactingAi,
    macroData,
    servings,
    setServings,
    aiError,
    setSaveToFavourites,
    saveToFavourites,
    uploadedImage,
    handleCreateNewMacroEntry,
    saving
  }
}

export default useMobileNewImage
